import has from 'lodash/has';
import stat from 'status/index';
import isEqual from 'lodash/isEqual';
import errorObj from './VuelidateErrorJSON';
import debounce from 'lodash/debounce';
import template from 'lodash/template';

export default {
    props: {
        value: {
            required: true,
            validator: prop => typeof prop === 'object'
                || typeof prop === 'string'
                || typeof prop === 'number'
                || typeof prop === 'boolean'
                || Array.isArray(prop)
                || prop === null
        },
        name: {
            type: String,
            default: '',
        },
        hideValidationStatus: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        hasValidation(){
            return typeof this.value === 'object'
                    && has(this.value, '$model');
        },
        validationValue(){
            return this.hasValidation
                ? this.value.$model
                : this.value;
        },
        hasError(){
            return this.hasValidation
                && (this.value.$dirty)
                && this.value.$invalid;
        },
        hasServerError(){
            return this.hasValidation
                && this.value.$invalid
                && has(this.value, 'server')
                && !this.value.server;
        },
        internalStatus(){
            if(this.status === stat.LOADING || this.hideValidationStatus){
                return this.status;
            }
            return this.hasError || this.hasServerError
                ? stat.ERROR
                : this.status;
        },
        messageArray(){
            let messageArray = [];
            if( (this.hasError || this.hasServerError) && !this.hideValidationStatus){
                messageArray = Object
                    .keys(this.value.$params)
                    .filter(key => !this.value[key])
                    .map(key => {
                        if(key === 'server'){
                            return this.value.$params.server.error.detail.join('');
                        }
                        if(has(errorObj, key)){
                            if(has(errorObj[key], 'placeholderDefaults')){
                                let placeholders = {
                                    ...errorObj[key].placeholderDefaults,
                                    ...this.value.$params[key]
                                };
                                if(this.name !== '') {
                                    placeholders.name = this.name;
                                }
                                return template(errorObj[key].message)(placeholders);
                            }
                            return errorObj[key].message;
                        }
                        return 'PlaceholderError';
                    });
            }
            return messageArray;
        },
        statusMessage(){
            return this.messageArray.length
                ? this.messageArray[0]
                : '';
        },
    },
    watch: {
        'value.$model'(newVal, oldVal){
            if(!isEqual(newVal,oldVal)) {
                this.debouncedTouch();
                this.clearServerErrors();
            }
        }
    },
    methods: {
        debouncedTouch: debounce(function(){
            this.value.$touch();
        }, 1000),
        input(value){
            if(this.hasValidation) {
                this.value.$model = value;
            } else {
                this.$emit('input', value);
            }
        },
        clearServerErrors(){
            if(this.hasServerError) {
                if(has(this.value, ['$params','server','clearError'])){
                    this.value.$params.server.clearError();
                }
                this.$emit('clear-error', this.value.$params.server.validationPath);
            }
        }
    },
    render() {
        return this.$scopedSlots.default({
            internalStatus: this.internalStatus,
            statusMessage: this.statusMessage,
            messageArray: this.messageArray,
            input: this.input,
            hasValidation: this.hasValidation,
            validationValue: this.validationValue,
            clearServerErrors: this.clearServerErrors,
        });
    },
};
